import { Address } from '../model/Address'

export { computeAddressSummary, computePraticeLocationSummary } from '@follow/cdk'

export function isInvalidAddress(address: Address) {
  return address.city === null && address.street === null && address.zipCode === null
}
